export const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
export const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/;
export const ACCOUNT_NUMBER_REGEX = /^[0-9]{9,18}$/;
export const MOBILE_REGEX = /^[6-9][0-9]{9}$/;
export const IFSC_VERIFY_DEBOUNCE_MS = 400;

// The backend stores `reason` as free text (mentorPanDetails.reason is a plain TEXT column,
// no enum) — value === label here so a previously-submitted reason prefills the dropdown
// correctly on re-edit instead of needing a slug-to-text reverse lookup.
export const OTHER_NO_PAN_REASON = "Other";

export const NO_PAN_REASONS = [
  "I have not applied for a PAN",
  "My PAN application is in progress",
  "My PAN application was rejected/needs correction",
  "I am unable to retrieve my PAN details",
  "I am a foreign national and do not have an Indian PAN",
  OTHER_NO_PAN_REASON,
].map((text) => ({ value: text, label: text }));

export const ACCOUNT_TYPES = [
  { value: "savings", label: "Savings" },
  { value: "current", label: "Current" },
  { value: "others", label: "Others" },
];

// verificationStatus values that mean "saved, but needs the mentor's attention"
export const PAN_STATUS_MESSAGES = {
  aadhaar_not_linked: "PAN verified, but Aadhaar isn't linked — 20% TDS will apply.",
  finance_review_required: "We need to manually review your details. We'll notify you once it's done.",
  failed: "We couldn't verify your PAN. Please check the details and try again.",
  retry_required: "Something went wrong while verifying. Please try again.",
};

export const BANK_STATUS_MESSAGES = {
  finance_review_required: "We need to manually review your details. We'll notify you once it's done.",
  failed: "We couldn't verify your bank account. Please check the details and try again.",
  retry_required: "Something went wrong while verifying. Please try again.",
};
